export interface ISnListItem {
  id: string;
}
